import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

import { DisplayMusicByToken } from "@/components/DisplayMusic";
const CATS = ["Popcorn", "Nachos", "Getränke", "Süßigkeiten", "Menüs", "Extras"];

export default function MenuDisplay() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/displays/public/${token}`).then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [token]);
  if (!d) return <div className="min-h-screen bg-black text-[#A8A398] flex items-center justify-center">Lade …</div>;

  return (
    <>
      <DisplayMusicByToken token={token} autoStart hideToggle />
      <div className="min-h-screen bg-black text-[#F5F0E6] p-10">
      <div className="text-center mb-8">
        <div className="font-heading text-6xl text-[#D4AF37]">Snackbar</div>
        <div className="text-xs mt-2 uppercase tracking-[0.4em] text-[#A8A398]">Menü & Preise</div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {CATS.map((c) => {
          const items = (d.products || []).filter((p) => p.category === c);
          if (!items.length) return null;
          return (
            <div key={c}>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] mb-3">{c}</div>
              <div className="space-y-2">
                {items.map((p) => (
                  <div key={p.id} className={`flex items-baseline justify-between py-2 border-b border-[#1A1A1A] ${p.available ? "" : "opacity-40"}`}>
                    <div>
                      <div className="font-heading text-xl">{p.name}</div>
                      {!p.available && <div className="text-[10px] text-[#EE9CA1] uppercase tracking-widest">Zurzeit nicht verfügbar</div>}
                    </div>
                    <div className="font-mono text-lg text-[#D4AF37]">{p.sell_price?.toFixed(2)} €</div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  
    </>);
}
